import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';

import { environment } from 'environments/environment';

import { Maintenance } from './maintenance.class';

import { Observable } from 'rxjs/Observable';

const BASE_PATH = '/ws/app/maintenance';
const BASE_URL = `${environment.API_URL}${BASE_PATH}`;

@Injectable()
export class MaintenanceService {

  constructor(
    public http: HttpClient
  ) {}

  public get(id): Observable<Maintenance> {
    return this.http.get(`${BASE_URL}/${id}`)
      .map((maintenanceData) => new Maintenance(maintenanceData));
  }

  public create(maintenance: Maintenance): Observable<Maintenance> {
    return this.http.post(BASE_URL, maintenance)
      .map((maintenanceData) => new Maintenance(maintenanceData));
  }

  public update(maintenance: Maintenance): Observable<any> {
    return this.http.put(`${BASE_URL}/${maintenance.id}`, maintenance);
  }

  public remove(id: string): Observable<any> {
    return this.http.delete(`${BASE_URL}/${id}`);
  }

  public all(): Observable<Maintenance[]> {
    return this.http.get(BASE_URL)
      .map((listMaintenanceData) =>
        (listMaintenanceData as any[]).map((maintenanceData) => new Maintenance(maintenanceData))
      );
  }

  public getImageUri(maintenanceId: string, imageId: string): string {
    return `${environment.API_URL}/ws/app/maintenance/${maintenanceId}/picture/${imageId}`;
  }

  public getPdfUri(id: string): string {
    return `${BASE_URL}/${id}/pdf`;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/maintenance.service.ts